import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';
import commonMessages from '@common/constraints/common.messages';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';

import Field from '@common/components/validation/field.validation';

import textUtils from '@common/helpers/text.utils';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';

import FocusHelper from '@common/helpers/focus.helper';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      showPassword: true,
    };
    this.alterVisiblePassword = this.alterVisiblePassword.bind(this);
  }

  validate(value) {
    const { TipoInput, NaoAceitaEspaco } = this.props;

    if (
      (TipoInput === 'emailSemEspacoEmBranco' || TipoInput === 'url') &&
      NaoAceitaEspaco &&
      value.trim().length > 0 &&
      !textUtils.validateSpacesOnString(value)
    )
      return commonMessages.validations.STRING_SPACE_INVALID;

    if (
      (TipoInput == 'email' || TipoInput == 'emailSemEspacoEmBranco') &&
      value &&
      value.trim().length > 0 &&
      !textUtils.validateEmail(value)
    )
      return commonMessages.validations.EMAIL_INVALID;
  }

  //validação para o campo password
  alterVisiblePassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  renderComponent() {
    const { props, validate } = this;
    const {
      Label,
      Tooltip,
      TipoInput,
      Obrigatorio,
      Desabilitado,
      Tamanho,
      TamanhoMinimo,
      Placeholder,
      name,
      onKeyDown,
      onKeyUp,
      PlacementTooltip,
    } = props;

    let buttonAlterVisiblePassword;
    if (TipoInput == 'password') {
      buttonAlterVisiblePassword = this.state.showPassword ? (
        <i style={{ cursor: 'pointer' }} className="fas fa-eye" onClick={this.alterVisiblePassword} />
      ) : (
        <i style={{ cursor: 'pointer' }} className="fas fa-eye-slash" onClick={this.alterVisiblePassword} />
      );
    }

    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChangeAsync, onBlur }) => {
          return (
            <LabeledInput {...props}>
              <OverlayTrigger
                key={`top-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-${name}`}>
                    <div className={'fontTooltip'}>{Tooltip || Label}</div>
                  </TooltipBootstrap>
                }
              >
                <div className="input-group">
                  <input
                    className={`form-control ${hasError ? 'form-invalid' : ''}`}
                    name={name}
                    type={this.state.showPassword ? TipoInput : 'text'}
                    value={value || ''}
                    disabled={Desabilitado}
                    required={Obrigatorio}
                    onChange={onChangeAsync}
                    maxLength={Tamanho}
                    minLength={TamanhoMinimo}
                    onBlur={onBlur}
                    placeholder={Placeholder || Label}
                    onKeyDown={onKeyDown}
                    onKeyUp={onKeyUp}
                  ></input>
                  {TipoInput == 'password' && (
                    <div className="input-group-append">
                      <div className="input-group-text">{buttonAlterVisiblePassword}</div>
                    </div>
                  )}
                </div>
              </OverlayTrigger>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control" readOnly>
                  {field.value || ''}
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{field.value || ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
